import { TenantConfig } from '@app/types/TenantConfig'
import steunpuntLogo from './assets/images/steunpunt-collectief-wonen.svg'
import { Footer } from './components/Footer'
import { TopNavBar } from './components/TopNavBar'

const steunpuntAmsterdamConfig: TenantConfig = {
  id: 'steunpunt-amsterdam',
  title: 'Steunpunt Collectief Wonen',
  domain: 'steunpunt-amsterdam.nl',
  logoUrl: steunpuntLogo,

  email: 'collectiefwonen@wooninfo.nl',
  phone: '020 523 0130',

  navigationComponent: <TopNavBar />,
  footerComponent: <Footer />,
}

export default steunpuntAmsterdamConfig
